import { getCurrencyLabel } from '../../helpers/currencies'
import { addCommaToPrice } from '../../helpers/numbers'
import { Currency } from '../../types/currency'

/** An amount as the wallet receipt shows it: the panel's own grouping, isolated from the text. */
export default function FollowUpAmount({
  amount,
  currency
}: {
  amount: number | null | undefined
  currency: string | null | undefined
}) {
  const label = currency ? getCurrencyLabel(currency as Currency) : ''
  return <bdi>{`${addCommaToPrice(amount ?? 0)} ${label}`.trim()}</bdi>
}
